<div style="margin:20px" fxLayout="column">
  <mat-dialog-content>
    <p *ngIf="data.isValid === undefined || data.isValid === false" id="p_desc">{{data.status}}</p>
    <span *ngIf="data.isValid !== undefined" fxLayout="column" fxLayoutGap="10px">
      <p *ngFor="let message of data.status" id="p_desc">{{message}}</p>
    </span>

  </mat-dialog-content>

  <mat-dialog-actions>
    <div fxLayout="column" fxFlex>
      <a fxLayoutAlign="end" *ngIf="!data.fromCreatePassword && !data.fromInactivity"
        style=" font-size: 18px ;text-align: end; cursor: pointer; color: #008c7f" (click)="okClicked()">{{ok}}</a>
      <a fxLayoutAlign="end" *ngIf="data.fromCreatePassword"
        style=" font-size: 18px ;text-align: end; cursor: pointer; color: #0014dc" (click)="okClicked()">Relogin Now</a>
      <a fxLayoutAlign="end" *ngIf="data.fromInactivity"
        style=" font-size: 18px ;text-align: end; cursor: pointer; color: #0014dc" (click)="okClicked()">{{refresh}}</a>
    </div>
  </mat-dialog-actions>
</div>
